module.exports = __webpack_public_path__ + "static/media/OTT.79c3405b.png";